import { render, staticRenderFns } from "./CardInfoV3.vue?vue&type=template&id=4aaa37c5&scoped=true&"
import script from "./CardInfoV3.vue?vue&type=script&lang=js&"
export * from "./CardInfoV3.vue?vue&type=script&lang=js&"
import style0 from "./CardInfoV3.vue?vue&type=style&index=0&id=4aaa37c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa37c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aaa37c5')) {
      api.createRecord('4aaa37c5', component.options)
    } else {
      api.reload('4aaa37c5', component.options)
    }
    module.hot.accept("./CardInfoV3.vue?vue&type=template&id=4aaa37c5&scoped=true&", function () {
      api.rerender('4aaa37c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/CardInfo/Merchant/CardInfoV3.vue"
export default component.exports